"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styleOverider = (left, right) => {
    if (!right)
        return left;
    return Object.assign(Object.assign({}, left), right);
};
exports.default = styleOverider;
